import { createRouter, createWebHashHistory } from 'vue-router';
import routes from './routes';

/**
 * In vue-router 3 il costruttore senza `mode` sceglieva **hash** per impostazione predefinita, e il
 * progetto se ne e sempre servito senza dichiararlo: tutti gli indirizzi in uso sono nella forma
 * `.../#/documenti`.
 *
 * In vue-router 4 quel valore predefinito non esiste piu, `history` e obbligatorio. Va scritto
 * `createWebHashHistory()` e non `createWebHistory()`: la seconda produrrebbe indirizzi puliti ma
 * romperebbe ogni collegamento salvato dagli utenti, e richiederebbe al server di riscrivere tutte
 * le rotte sull'`index.html` - due cambiamenti veri, che non hanno niente a che vedere con questo
 * aggiornamento e che vanno decisi a parte.
 */
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
